export default __webpack_public_path__ + "static/media/report.f901f1ce.svg";